import {
  AllTypeResourceItem,
  GridKubernetesResourceDataResponse,
} from "../types/resources";
import { kubernetesResourceTypes } from "@/store/resources-grid/utils/constants/common";

export const isResourceKubernetes = (
  resource: AllTypeResourceItem,
): resource is GridKubernetesResourceDataResponse["resource"] => {
  return resource && kubernetesResourceTypes.has(resource.resource_type);
};
